import { observer } from 'mobx-react';
import React from 'react';

import { Button } from '@mui/material';
import Form from 'components/Form';
import Modal, { IModalProps } from 'components/Modal';
import GrowTransition from 'components/Modal/animations/grow';

import SelectField from '@common/components/Form/SelectField';
import TextField from '@common/components/Form/TextField';

import StyledAppointmentsBookingModalForm from './styled';

interface BookingFormValues {
	day: string;
	time: string;
	format: string;
	phone: string;
}

interface PropsType extends Omit<IModalProps, 'title' | 'onSubmit'> {
	initialValues: any;
	onSave: (data: BookingFormValues) => void;
	submitButtonText?: string;
}

function AppointmentsBookingModal({
	initialValues,
	onSave,
	submitButtonText = 'Book',
	...props
}: PropsType) {
	return (
		<Modal
			PaperProps={{
				sx: {
					maxWidth: '500px',
				},
			}}
			title="Booking"
			TransitionComponent={GrowTransition}
			transitionDuration={500}
			{...props}
		>
			<Form initialValues={initialValues} onSave={onSave} hideActions>
				<StyledAppointmentsBookingModalForm>
					<TextField name="day" disabled label="Day" />
					<TextField name="time" disabled label="Time" />
					<TextField name="phone" label="Phone" />
					<SelectField
						label="Format"
						name="format"
						sx={{
							borderRadius: '10px',
							background: '#FFF',
							overflow: 'hidden',
							boxShadow: '5px 4px 10.8px 0px rgba(166, 203, 245, 0.28)',
							border: 'none',
						}}
						options={[
							{
								label: 'Online',
								value: 'online',
							},
							{
								label: 'Offline',
								value: 'offline',
							},
						]}
					/>
					<TextField label="Comment" name="comment_student" />
					<Button variant="contained" type="submit">
						{submitButtonText}
					</Button>
				</StyledAppointmentsBookingModalForm>
			</Form>
		</Modal>
	);
}

export default observer(AppointmentsBookingModal);
